import * as api from '../api/rolesApi';
import * as types from '../constants/rolesConstants';
import { toast } from 'react-toastify';

export const getRolesAction = () => async (dispatch) => {
  dispatch({ type: types.GET_ROLES_REQUEST });
  try {
    const { error, data } = await api.getRoles();
    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_ROLES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список ролей');
    dispatch({ type: types.GET_ROLES_FAILURE });
  }
};

export const clearRolesAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_ROLES,
  });
};
